<script>
  import SelecaoCursos from './SelecaoCursos'
  import DadosPessoais from './DadosPessoais'
  import Confirmacao from './Confirmacao'
  import {get, set} from '@utils/storage'
  import * as $vestibularService from '../../services/vestibularService'
  import bus from '@utils/bus'

  export default {
    components: {SelecaoCursos, DadosPessoais, Confirmacao},
    data () {
      return {
        step: 1,
        opcoes: {},
        form: {},
        selecaoCursosValido: false,
        dadosPessoaisValido: false
      }
    },
    watch: {
      '$route': function (to) {
        this.checarStep(to)
      },
      step: function () {
        if (this.step === '1') {
          console.log(this.step)
          this.$router.push({name: 'etapas'})
        } else if (this.step === '2') {
          this.$router.push({name: 'dados-pessoais'})
        } else if (this.step === '3') {
          this.$router.push({name: 'confirmacao'})
        }
      }
    },
    computed: {
      habilitarProximo: function () {
        this.checarStep(this.$route)
        return (this.step === 1 && this.selecaoCursosValido) || (this.step === 2 && this.dadosPessoaisValido)
      }
    },
    mounted (to) {
      this.checarStep(this.$route)
    },
    methods: {
      checarStep (to) {
        if (to.name === 'selecao-cursos' || to.name === 'etapas') {
          this.step = 1
        } else if (to.name === 'dados-pessoais') {
          this.step = 2
        } else if (to.name === 'confirmacao') {
          this.step = 3
        }
      },
      async onProximo () {
        let opcoesCurso = await get('opcoes')
        let form = {...await get('form')}
        form.opcoes.splice(0)
        opcoesCurso
        .filter(item => {
          if (item.opcao !== null) {
            form.opcoes.push(item.ref_oferta_curriculo)
          }
        })
        set('form', form)
        $vestibularService.gravaPreIncricao(form)
        .then(response => {
          bus.$emit('hide-loader')
          if (this.step === 1) {
            bus.$emit('hide-loader')
            this.$router.push({name: 'dados-pessoais'})
          } else {
            bus.$emit('hide-loader')
            this.$router.push({name: 'confirmacao'})
          }
        })
      },
      onVoltar () {
        if (this.step === 2) {
          this.$router.push({name: 'etapas'})
        } else {
          this.$router.push({name: 'dados-pessoais'})
        }
      },
      async gravaInscricao () {
        let form = {...await get('form')}
        $vestibularService.gravaIncricao(form)
        .then(response => {
          set('inscricao', response).then(() => {
            bus.$emit('hide-loader')
            this.$router.push({name: 'finalizacao'})
          })
        })
      }
    }
  }
</script>
<template>
  <v-content>
    <v-container id="etapas">
      <v-stepper v-model="step" alt-labels class="box-step" color="text--lighten-1">
        
        <v-stepper-header>
          
          <v-stepper-step color="step" edit-icon="$vuetify.icons.complete" :complete="step > 1" step="1" :editable="step >= 1">Curso</v-stepper-step>
          
          <v-divider></v-divider>
          
          <v-stepper-step color="step" edit-icon="$vuetify.icons.complete" :complete="step > 2" step="2" :editable="step >= 2">Dados Pessoais</v-stepper-step>
          
          <v-divider></v-divider>
          
          <v-stepper-step color="step" step="3">Confirmação</v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" >

             <selecao-cursos :valido.sync="selecaoCursosValido" />

          </v-stepper-content>
          <v-stepper-content step="2" >

            <dados-pessoais :valido.sync="dadosPessoaisValido" />

          </v-stepper-content>
          <v-stepper-content step="3">

             <confirmacao />

          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-layout row wrap>
        <v-flex xs6 class="pa-0">
          <v-btn class="ml-0" v-if="step > 1" color="success"  @click="onVoltar()">Voltar</v-btn>
        </v-flex>

        <v-flex xs6 text-xs-right>          
          <v-btn class="ma-0 mt-2"
            v-if="step != 3"
            color="primary"
            @click="onProximo()"
            :disabled="!habilitarProximo"
            >
            Próximo
            </v-btn>

            <v-btn class="ma-0 mt-2"
            v-if="step === 3"
            color="primary"
            @click="gravaInscricao()"
            >
            Confirmar
            </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>
<style lang="scss">
body {
  background-color: #000;
}
.box-step {
  color: #fff !important;
  
  .title {
    font-size: 16px !important;
    color: #8F9E50;
  }
  .step {
    background-color: #8F9E50 !important;
  }
}
#etapas {
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// Etapas.vue?c3a70a20